/* Product list in tab
   Asset: tfg-product-tabs.js
   Used by: Product list in tab section
*/

(function () {
  if (window.TFGProductTabs && window.TFGProductTabs.initialized) {
    window.TFGProductTabs.initAll();
    return;
  }

  const productTabs = window.TFGProductTabs || {};

  function initSection(section) {
    if (!section || section.dataset.productTabsReady === 'true') return;

    const tabs = section.querySelectorAll('.tab_options .tab_trigger');
    const panels = section.querySelectorAll('.tab_content .tab_block');

    if (!tabs.length || !panels.length) return;

    function activateTab(tab) {
      const targetId = tab.getAttribute('data-tab');
      if (!targetId) return;

      tabs.forEach(function (item) {
        const isActive = item === tab;
        item.classList.toggle('active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        const isActive = panel.id === targetId;
        panel.classList.toggle('active', isActive);
        panel.hidden = !isActive;
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });
    });

    const activeTab = section.querySelector('.tab_options .tab_trigger.active') || tabs[0];
    activateTab(activeTab);

    section.dataset.productTabsReady = 'true';
  }

  function initAll(root) {
    const scope = root || document;
    const sections = scope.querySelectorAll
      ? scope.querySelectorAll('[data-product-tabs]')
      : [];

    sections.forEach(initSection);
  }

  productTabs.initAll = initAll;
  productTabs.initialized = true;
  window.TFGProductTabs = productTabs;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
